var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 115,
    viewBox: "0 0 195 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 19.4062,
    width: 129.721,
    height: 93.5951,
    rx: 6,
    stroke: "#4B43FF",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.516 6.61283L164.162 26.6173L184.142 31.9772C183.438 34.6037 182.225 37.0659 180.571 39.2231C178.918 41.3802 176.856 43.1902 174.504 44.5496C172.151 45.909 169.555 46.7911 166.862 47.1457C164.169 47.5004 161.433 47.3205 158.809 46.6163C156.186 45.9129 153.726 44.6989 151.572 43.0436C149.417 41.3883 147.609 39.3242 146.251 36.9691C144.893 34.6141 144.011 32.0142 143.657 29.318C143.303 26.6218 143.482 23.8822 144.186 21.2555C145.605 15.9507 149.072 11.4278 153.822 8.68177C158.572 5.93574 164.218 5.19151 169.516 6.61283Z",
    fill: "#4B43FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.933 0.00018214C183.78 1.56864 188.765 5.39819 191.791 10.6463C194.818 15.8945 195.638 22.1314 194.071 27.985L172.026 22.0711L177.933 0.00018214Z",
    fill: "#4B43FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 29.7047,
    height: 2.83067,
    rx: 1.41534,
    transform: "matrix(0.865772 -0.500439 0.499561 0.866279 102 65.4551)",
    fill: "#A8A3FB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 15.5596,
    height: 2.83067,
    rx: 1.41534,
    transform: "matrix(0.865772 -0.500439 0.499561 0.866279 121.732 45.875)",
    fill: "#A8A3FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9.90155,
    height: 2.83067,
    rx: 1.41534,
    transform: "matrix(0.865772 -0.500439 0.499561 0.866279 110.711 52.248)",
    fill: "#A8A3FB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 29.7047,
    height: 2.83067,
    rx: 1.41534,
    transform: "matrix(0.865772 -0.500439 0.499561 0.866279 120.23 63.0918)",
    fill: "#A8A3FB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.e36e6cdf1e5ff9ca166c61b03f26eacf.svg";
export { ForwardRef as ReactComponent };